import React, { Component } from "react";
import PropTypes from "prop-types";

import "./styles.css";
import Parcela from "./Parcela";

export default class AcordoParcelas extends Component {
  static propTypes = {
    parcelas: PropTypes.array,
    acordo: PropTypes.object,
    handleUpdate: PropTypes.func
  };

  render() {
    const sortedParcelas = this.props.parcelas.sort(
      (a, b) => a.num_parcela - b.num_parcela
    );

    return (
      <div style={{ overflowX: "auto" }}>
        <h1 className="acordoview__title">Parcelas</h1>
        <table className="acordoview__table">
          <thead>
            <tr>
              <th>Nº PARCELA</th>
              <th>VALOR PARC.</th>
              <th>VENCIMENTO</th>
              <th>VALOR PAGO</th>
              <th>DATA PAGAMENTO</th>
              <th>FORMA PAGAMENTO</th>
              <th>OPERADOR</th>
              <th>RECEBER</th>
              <th>NOTA FISCAL</th>
              <th>STATUS HO</th>
              <th>VALOR HO</th>
            </tr>
          </thead>
          <tbody>
            {sortedParcelas.map(parcela => (
              <Parcela
                key={parcela.id}
                parcela={parcela}
                acordo={this.props.acordo}
                handleUpdate={this.props.handleUpdate}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoParcelas/index.js